import { GetEmployeeResponseDTO } from '@/core/dto/psychosocial-report';
import type { Employee } from '@/types/Psychosocial';

export class GetEmployeeMapper {
	constructor(private readonly data: GetEmployeeResponseDTO) {}

	toDomain(): Employee {
		return {
			organization_id: this.data.organization_id,
			admission_date: this.data.admission_date,
			employee_code: this.data.employee_code,
			workstations: this.data.workstations,
			company_id: this.data.company_id,
			birth_date: this.data.birth_date,
			work_shift: this.data.work_shift,
			education: this.data.education,
			cellules: this.data.cellules,
			sectors: this.data.sectors,
			gender: this.data.gender,
			email: this.data.email,
			role: this.data.role,
			name: this.data.name,
			id: this.data.id
		};
	}
}
